import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';

export const RankRow = ({ j, i }) => (
  <Link to={`/jueces/${j.judge_id}`} data-testid={`ranking-judge-${j.judge_id}`} className="flex items-center gap-3 rounded-xl border border-slate-800 bg-slate-900/40 px-3 py-2 transition-colors hover:border-amber-500/60">
    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${i === 0 ? 'bg-amber-400 text-slate-950' : 'bg-slate-800 text-slate-300'}`}>{i + 1}</span>
    <div className="min-w-0 flex-1">
      <p className="truncate text-sm text-white">{j.name}{j.estilo && <span className="ml-1 text-[11px] text-amber-300">· {j.estilo}</span>}</p>
      <p className="truncate text-[11px] text-slate-500">{j.position} · {j.court}</p>
    </div>
    <div className="text-right">
      <p data-testid={`ranking-rate-${j.judge_id}`} className={`text-sm font-semibold ${j.win_rate >= 50 ? 'text-emerald-300' : 'text-rose-300'}`}>{j.win_rate}%</p>
      <p className="text-[10px] text-slate-500">{j.won}G · {j.lost}P</p>
    </div>
  </Link>
);

// Ranking of judges by wins in the firm's closed cases, grouped by region
export const JudgeRanking = ({ data }) => {
  if (!data) return null;
  if (data.error) return <p data-testid="ranking-error" className="mt-6 text-sm text-rose-300">No se pudo cargar el ranking. Inténtalo nuevamente.</p>;
  return (
    <div data-testid="judge-ranking" className="mt-6 space-y-6">
      <p data-testid="ranking-scope" className="text-xs text-slate-400">
        <Trophy className="mr-1 inline h-3.5 w-3.5 text-amber-400" />
        {data.scope === 'firma' ? `Causas cerradas de toda tu notaría o estudio (@${data.domain}, ${data.lawyers} usuario(s))` : 'Tus causas cerradas (correo personal: solo cuentan tus causas)'} · {data.closed_cases} causa(s) con juez asignado
      </p>
      {!data.regions.length && <p data-testid="ranking-empty" className="rounded-2xl border border-slate-800 p-6 text-sm text-slate-400">Aún no hay causas cerradas con juez asignado. Al marcar una causa como ganada o perdida en el CRM, el juez aparecerá aquí.</p>}
      {data.regions.map((r) => (
        <section key={r.region} data-testid={`ranking-region-${r.region}`}>
          <h2 className="mb-2 text-base font-semibold text-white">Región {r.region}</h2>
          <div className="grid gap-2 md:grid-cols-2">{r.judges.map((j, i) => <RankRow key={j.judge_id} j={j} i={i} />)}</div>
        </section>
      ))}
    </div>
  );
};
